// extracted by mini-css-extract-plugin
module.exports = {"main":"course-content-display-module--main--35CUE","smallText":"course-content-display-module--small-text--3m0cQ","dayTitle":"course-content-display-module--dayTitle--2ivVb"};